/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Fragment } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import FocusRing from '@atlaskit/focus-ring';
import { useTabPanel } from '../hooks';
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */
const TabPanel = ({
  children,
  testId
}) => {
  const {
    role,
    id,
    hidden,
    'aria-labelledby': ariaLabelledBy,
    tabIndex
  } = useTabPanel();
  return jsx(FocusRing, {
    isInset: true
  }, jsx("div", {
    "data-testid": testId,
    role: role,
    id: id,
    hidden: hidden,
    "aria-labelledby": ariaLabelledBy,
    tabIndex: tabIndex
  }, jsx(Fragment, null, children)));
};
export default TabPanel;